export default __webpack_public_path__ + "static/media/infernal-linnorm.a040f398.jpeg";